<script setup lang="ts">
import { NIcon } from '@nio-fe/icon';
import { ref } from 'vue';
import ICON_ADD_GROUP from '@/assets/images/icon_add_group_chat.svg';
import useGlobalStore from '@/store/globalStore';
import { noticeMicro } from '@/utils/messageHandler';
import { useGlobalRouteStore } from '@/store/globalRouteStore';
import useMatestoreStore from '@/store/matestoreStore';
interface CreationMenuItem {
  label: string;
  permission: string;
  key: string;
  icon: string;
  iconType: 'img' | 'icon';
}

const props = withDefaults(
  defineProps<{
    theme: string;
  }>(),
  {
    theme: 'v1',
  }
);

const menus = ref<CreationMenuItem[]>([]);
const globalStore = useGlobalStore();
const routeStore = useGlobalRouteStore();
const microStore = useMatestoreStore();
const ALL_MENUS: CreationMenuItem[] = [
  {
    label: '新建群聊',
    permission: 'message',
    key: 'group',
    icon: ICON_ADD_GROUP,
    iconType: 'img',
  },
  {
    label: '新建试驾',
    permission: '/testDriveOrder/create',
    key: 'testdrive',
    icon: 'car',
    iconType: 'icon',
  },
];

const generateCreationMenu = () => {
  return ALL_MENUS.filter((i) => globalStore.hasAuthority(i.permission));
};

menus.value = generateCreationMenu();

const handleClickMenuItem = (type) => {
  switch (type) {
    case 'testdrive':
      routeStore.push('/test-drive#/testDriveOrder/create');
      break;
    case 'group':
      microStore.openImMicro();
      noticeMicro('im', { action: 'createGroup' });
      break;
  }
};
</script>

<template>
  <n-dropdown v-if="menus.length" align="right" trigger="click">
    <n-button
      v-tit-tracker:click="{
        button_group: '新建',
        button_name: '新建',
        trackName: 'FrameClick',
        requirement_id: 754,
        track_sign: 'aplatform.b2862.c2866.click.FrameClick',
      }"
      v-tooltip.bottom="{ content: '新建', distance: 20 }"
      class="mate-btn-reverse-icon"
      type="text"
      icon="add"
    >
    </n-button>
    <n-dropdown-menu>
      <n-dropdown-item
        v-for="item in menus"
        :key="item.key"
        class="menu-item"
        v-tit-tracker:click="{
          button_group: '新建',
          button_name: item.label,
          trackName: 'FrameClick',
          requirement_id: 754,
          track_sign: 'aplatform.b2862.c2866.click.FrameClick',
        }"
        @click="handleClickMenuItem(item.key)"
        ><img
          v-if="item.iconType === 'img'"
          class="n-icon"
          :src="item.icon"
        /><NIcon v-if="item.iconType === 'icon'" :name="item.icon" />{{
          item.label
        }}</n-dropdown-item
      >
    </n-dropdown-menu>
  </n-dropdown>
</template>

<style scoped lang="scss">
.menu-item {
  :deep(.n-icon) {
    margin-right: 8px;
  }
}
.tit-top-header-add-icon {
  display: block;
  color: var(--tit-header-label-color);
}
</style>
